<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-primary text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-white">{{ $t("Vehicle Information") }}</h5>
                <span
                  v-if="vehicle"
                  :class="[getStatusClass(vehicle.status), 'ml-2']"
                >
                  {{ getStatusLabel(vehicle.status) }}
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver
                    ref="formObserver"
                    v-slot="{ validate, invalid }"
                  >
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <div class="form-group col-md-3">
                          <div>
                            <label for="Name">
                              <span class="required" v-if="!vehicle.id">*</span>
                              {{ $t("Assignment") }}:
                            </label>
                            <div class="d-flex align-items-center">
                              <b-form-input
                                id="name"
                                type="text"
                                v-model="vehicle.name"
                                :disabled="true"
                                :title="
                                  $t('This field is managed via Assignments')
                                "
                                style="flex: 1"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="License Plate"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="license_plate">
                              <span class="required">*</span>
                              {{ $t("License Plate") }}:
                            </label>
                            <b-input-group>
                              <b-form-input
                                :key="placaMask"
                                type="text"
                                id="license_plate"
                                v-mask="placaMask"
                                v-model="vehicle.license_plate"
                                @input="
                                  vehicle.license_plate = (
                                    vehicle.license_plate || ''
                                  ).toUpperCase()
                                "
                                :state="errors.length ? false : null"
                                :placeholder="
                                  isMercosul ? 'AAA1A23' : 'AAA-1234'
                                "
                              />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-secondary"
                                  @click="toggleMercosul"
                                  style="
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 10px;
                                  "
                                  title="Alternar tipo de placa"
                                >
                                  <span class="mr-2">
                                    {{
                                      isMercosul ? $t("Mercosur") : $t("Old")
                                    }}
                                  </span>
                                  <b-form-checkbox
                                    switch
                                    :checked="isMercosul"
                                    @change="toggleMercosul"
                                  />
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <label for="frame">{{ $t("Frame") }}:</label>
                          <b-form-input
                            type="text"
                            id="frame"
                            v-model="vehicle.frame"
                          />
                        </div>

                        <div class="form-group col-md-2">
                          <label for="national_registry"
                            >{{ $t("National car registration") }}:</label
                          >
                          <b-form-input
                            type="text"
                            id="national_registry"
                            v-model="vehicle.national_registry"
                          />
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="Color"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="vehicle_colors">
                              <span class="required">*</span> {{ $t("Color") }}:
                            </label>
                            <v-select
                              :options="vehicle_colors"
                              :reduce="(color) => color.id"
                              label="name"
                              v-model="vehicle.color_id"
                              class="vselect"
                              :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="Vehicle Brand"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="vehicle_brands">
                              <span class="required">*</span>
                              {{ $t("Vehicle Brand") }}:
                            </label>
                            <v-select
                              :options="vehicle_brands"
                              :reduce="(brand) => brand.id"
                              label="name"
                              v-model="vehicle.vehicle_brand_id"
                              class="vselect"
                              :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-4">
                          <ValidationProvider
                            name="Vehicle Model"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="vehicle_models">
                              <span class="required">*</span>
                              {{ $t("Vehicle Model") }}:
                            </label>
                            <v-select
                                :options="filteredVehicleModels"
                                :reduce="model => model.id"
                                label="name"
                                v-model="vehicle.vehicle_model_id"
                                class="vselect"
                                :class="{ 'is-invalid': errors.length }"
                                :disabled="!vehicle.vehicle_brand_id"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Manufacture Year"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="manufacture_year">
                              <span class="required">*</span>
                              {{ $t("manufacture Year") }}:
                            </label>
                            <b-form-input
                              type="text"
                              id="manufacture_year"
                              v-model="vehicle.manufacture_year"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Model Year"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="model_year">
                              <span class="required">*</span>
                              {{ $t("model Year") }}:
                            </label>
                            <b-form-input
                              type="text"
                              id="model_year"
                              v-model="vehicle.model_year"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Tracking Token"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="tracking_token">
                              <span class="required">*</span>
                              {{ $t("Tracking Token") }}:
                            </label>
                            <b-form-input
                              type="text"
                              id="tracking_token"
                              v-model="vehicle.tracking_token"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Status"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="status">
                              <span class="required">*</span>
                              {{ $t("Status") }}:
                            </label>
                            <v-select
                              class="vselect"
                              :options="status"
                              :reduce="(option) => option.id"
                              label="name"
                              v-model="vehicle.status"
                              :disabled="true"
                              :searchable="false"
                              :clearable="false"
                              :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                              $t(errors[0])
                            }}</span>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-12">
                          <ValidationProvider
                            name="Description"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="description">
                              <span class="required">*</span>
                              {{ $t("Description") }}:
                            </label>
                            <b-form-textarea
                              id="description"
                              v-model="vehicle.description"
                              :state="errors.length ? false : null"
                              rows="5"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Maintenance Free"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="maintenance_free">
                              <span class="required">*</span>
                              {{ $t("maintenance free") }}:
                            </label>
                            <b-form-select
                              id="maintenance_free"
                              v-model="vehicle.maintenance_free"
                              :options="[
                                { value: 1, text: $t('Yes') },
                                { value: 0, text: $t('No') },
                              ]"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Checklist Free"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="checklist_free">
                              <span class="required">*</span>
                              {{ $t("checklist free") }}:
                            </label>
                            <b-form-select
                              id="checklist_free"
                              v-model="vehicle.checklist_free"
                              :options="[
                                { value: 1, text: $t('Yes') },
                                { value: 0, text: $t('No') },
                              ]"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-3">
                          <ValidationProvider
                            name="Mileage"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label for="mileage">
                              <span class="required">*</span>
                              {{ $t("mileage") }}:
                            </label>
                            <b-form-input
                              type="text"
                              id="mileage"
                              v-model="vehicle.mileage"
                              :state="errors.length ? false : null"
                            />
                            <b-form-invalid-feedback>{{
                              $t(errors[0])
                            }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>

                        <div class="form-group col-md-12">
                          <label for="crlv"> {{ $t("Insert CRLV") }}: </label>
                          <upload-file
                            :fileId="vehicle.crlv"
                            @uploaded="onUploadedCrlv"
                            :showButtons="false"
                          />
                        </div>
                      </div>

                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong>{{ $t("Required Fields") }}</strong>
                      </span>

                      <div class="block text-right">
                        <b-button
                          variant="outline-secondary"
                          class="btn btn-back"
                          @click="$router.go(-1)"
                        >
                          <i class="fa fa-arrow-left"></i>
                          {{ $t("To Go Back") }}
                        </b-button>
                        <b-button
                          type="submit"
                          variant="primary"
                          class="ml-1"
                          :disabled="
                            vehicle.id
                              ? loading
                              : loading || invalid || !isPendingAssignmentValid
                          "
                        >
                          <template v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i>
                            {{ $t("Saving") }}...
                          </template>
                          <template v-else>
                            {{ $t("Save") }} <i class="fa fa-save"></i>
                          </template>
                        </b-button>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="margin-top: 20px">
          <div v-if="initializing" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
            <p class="mt-2">{{ $t("Loading assignments") }}...</p>
          </div>
          <div v-else>
            <div v-if="!vehicle.id">
              <div class="card">
                <div class="card-header">
                  <strong>{{ $t("Assignment") }}</strong>
                </div>
                <div class="card-body">
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label
                        >{{ $t("Assignment Name") }}
                        <span class="required">*</span></label
                      >
                      <b-form-input v-model="pendingAssignment.name" />
                    </div>
                    <div class="form-group col-md-4">
                      <label
                        >{{ $t("Vehicle Type") }}
                        <span class="required">*</span></label
                      >
                      <v-select
                        :options="vehicleTypes"
                        :reduce="(t) => t.id"
                        label="sigla"
                        v-model="pendingAssignment.vehicle_type_id"
                        class="vselect"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{ $t("Specialty") }}:</label>
                      <b-form-input
                        type="text"
                        :value="pendingAssignment.specialty"
                        disabled
                      />
                    </div>
                    <!--                    <div class="form-group col-md-4">-->
                    <!--                      <label>{{ $t('Telephone Pulsos') }} <span class="required">*</span></label>-->
                    <!--                      <b-form-input v-model="pendingAssignment.telephone_pulsos" v-mask="'(##) #####-####'" placeholder="(00) 00000-0000" />-->
                    <!--                    </div>-->
                    <div class="form-group col-md-4">
                      <label
                        >{{ $t("Center") }}
                        <span class="required">*</span></label
                      >
                      <v-select
                        :options="centers"
                        :reduce="(center) => center.id"
                        label="name"
                        v-model="pendingAssignment.center_id"
                        @input="loadPendingUnitsForCenter"
                        class="vselect"
                      />
                    <!-- </div>
                    <div class="form-group col-md-4">
                      <ValidationProvider
                        name="Unit"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label
                          >{{ $t("Unit") }}
                          <span class="required">*</span></label
                        >
                        <b-form-select
                          v-model="pendingAssignment.unit_id"
                          :options="pendingTransferUnits"
                          :state="errors.length > 0 ? false : null"
                          @input="onUnitChange"
                        />
                        <b-form-invalid-feedback>{{
                          $t(errors[0])
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                    <div class="form-group col-md-4">
                      <label
                        >{{ $t("Start Date") }}
                        <span class="required">*</span></label
                      >
                      <b-form-input
                        type="date"
                        v-model="pendingAssignment.start_date"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{ $t("Notes") }}</label>
                      <b-form-input v-model="pendingAssignment.notes" />
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{ $t("Devices") }}</label>
                      <v-select
                        :options="devices"
                        :multiple="true"
                        :reduce="(d) => d.id"
                        label="display"
                        v-model="pendingAssignment.device_ids"
                        class="vselect"
                        :disabled="devicesLoading"
                        :placeholder="
                          devicesLoading
                            ? $t('Loading devices...')
                            : $t('Select devices')
                        "
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{ $t("Carnival") }}</label>
                      <b-form-select
                        v-model="pendingAssignment.is_carnival"
                        :options="[
                          { value: 0, text: $t('No') },
                          { value: 1, text: $t('Yes') },
                        ]"
                      /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <VehicleAssignments
                :vehicleId="vehicle.id"
                @assignment-changed="onAssignmentChanged"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import axios from "axios";
import vSelect from "vue-select";
import UploadFile from "../../layouts/components/UploadFile";
import VehicleAssignments from "./components/VehicleAssignments.vue";
import { mask } from "vue-the-mask";

extend("required", required);

const LEVEL = {
  0: "Inactive",
  1: "Active",
};

const LEVEL_CLASS = {
  0: "badge bg-secondary",
  1: "badge bg-success",
};

export default {
  name: "VehicleForm",
  directives: { mask },
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    UploadFile,
    VehicleAssignments,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      loading: false,
      pendingLoading: true,
      checkingVehicle: false,
      initializing: true,
      isMercosul: false,
      vehicle: {
        status: 1,
        level: 0,
        name: "",
        license_plate: "",
        vehicle_type_id: null,
        center_id: null,
        unit_id: null,
        frame: "",
        national_registry: "",
        color_id: "",
        vehicle_brand_id: "",
        vehicle_model_id: "",
        manufacture_year: "",
        model_year: "",
        description: "",
        maintenance_free: 0,
        checklist_free: 0,
        mileage: "",
        crlv: "",
        tracking_token: "",
      },
      vehicle_colors: [],
      vehicle_brands: [],
      vehicle_models: [],
      status: [
        { name: this.$t("Inactive"), id: 0 },
        { name: this.$t("Active"), id: 1 },
      ],
      errors: undefined,
      pendingAssignment: {
        name: "",
        vehicle_type_id: null,
        specialty: "",
        center_id: null,
        unit_id: null,
        start_date: "",
        notes: "",
        device_ids: [],
        is_carnival: 0,
      },
      vehicleTypes: [],
      centers: [],
      pendingTransferUnits: [],
      devices: [],
      devicesLoading: false,
      _cancelSource: null,
    };
  },
  computed: {
    apiBase() {
      return this.$store && this.$store.state ? this.$store.state.api : "";
    },
    isPendingAssignmentValid() {
      const pending = this.pendingAssignment;
      return !!(
        pending &&
        pending.name &&
        pending.vehicle_type_id &&
        // pending.telephone_pulsos &&
        pending.center_id &&
        pending.unit_id &&
        pending.start_date
      );
    },
    filteredVehicleModels() {
      if (!this.vehicle.vehicle_brand_id) return this.vehicle_models || [];
      return (this.vehicle_models || []).filter(
        (m) =>
          String(m.vehicle_brand_id) === String(this.vehicle.vehicle_brand_id),
      );
    },
    placaMask() {
      return this.isMercosul ? "AAA#A##" : "AAA-####";
    },
  },
  methods: {
    normalizePayload(payload) {
      const p = Object.assign({}, payload);
      if (p.crlv && typeof p.crlv === "object") {
        if (p.crlv.id) p.crlv = p.crlv.id;
        else if (p.crlv._id) p.crlv = p.crlv._id;
        else p.crlv = String(p.crlv);
      }
      return p;
    },
    getCreatedVehicleId(response) {
      if (!response || !response.data) return null;
      const d = response.data;
      if (d.id) return d.id;
      if (d.data) {
        if (Array.isArray(d.data) && d.data[0] && d.data[0].id)
          return d.data[0].id;
        if (d.data.id) return d.data.id;
      }
      return null;
    },
    async ensureCrlvPersisted(vehicleId, crlv) {
      if (!crlv || !vehicleId) return;
      const putApi = `${this.apiBase}vehicles/${vehicleId}`;
      await axios.put(
        putApi,
        { crlv },
        {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        },
      );
    },
    async createPendingAssignment(vehicleId) {
      if (!vehicleId) return;
      const assignApi = `${this.apiBase}vehicle_assignments`;
      const assignPayload = Object.assign(
        { vehicle_id: vehicleId },
        this.pendingAssignment,
      );
      if (!assignPayload.notes) assignPayload.notes = "Criação";
      await axios.post(assignApi, assignPayload, {
        cancelToken: this._cancelSource ? this._cancelSource.token : undefined,
      });
    },
    onUploadedCrlv(uploadedId) {
      const n = Number(uploadedId);
      this.vehicle.crlv = Number.isFinite(n) ? n : uploadedId;
    },
    async handleSubmit(validate) {
      try {
        if (this.vehicle && this.vehicle.id) {
          this.loading = true;
          await this.save();
          return;
        }

        const isValid = await validate();
        if (!isValid) {
          this.$message(
            this.$t("Error"),
            this.$t("Please fill all required fields"),
            "danger",
          );
          return;
        }

        this.loading = true;
        await this.save();
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    toggleMercosul() {
      this.isMercosul = !this.isMercosul;
      this.vehicle.license_plate = "";
    },
    getStatusLabel(index) {
      return this.$t(LEVEL[index]);
    },
    getStatusClass(index) {
      return LEVEL_CLASS[index];
    },
    async save() {
      try {
        const api = `${this.apiBase}vehicles`;
        const payload = this.normalizePayload(this.vehicle);

        if (this.vehicle && this.vehicle.id) {
          const putUrl = `${api}/${this.vehicle.id}`;
          await axios.put(putUrl, payload, {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          });

          this.$message(
            this.$t("Success"),
            this.$t("Information saved successfully"),
            "success",
          );
          this.$router.push("/vehicles");
          return;
        }

        if (!this.isPendingAssignmentValid) {
          this.$message(
            this.$t("Error"),
            this.$t(
              "Please fill assignment information before saving the vehicle",
            ),
            "danger",
          );
          return;
        }

        Object.assign(payload, {
          name: this.pendingAssignment.name,
          vehicle_type_id: this.pendingAssignment.vehicle_type_id,
          center_id: this.pendingAssignment.center_id,
          unit_id: this.pendingAssignment.unit_id,
          start_date: this.pendingAssignment.start_date,
          notes: this.pendingAssignment.notes || "Criação",
          device_ids: this.pendingAssignment.device_ids || [],
          is_carnival: this.pendingAssignment.is_carnival,
        });

        const response = await axios.post(api, payload, {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        });
        const vehicleId = this.getCreatedVehicleId(response);

        try {
          await this.createPendingAssignment(vehicleId);
          this.$message(
            this.$t("Success"),
            this.$t("Vehicle and assignment created successfully"),
            "success",
          );
          this.$router.push("/vehicles");
        } catch (e) {
          const resp =
            e && e.response && e.response.data ? e.response.data : null;
          let conflictIds = [];
          try {
            if (
              resp &&
              Array.isArray(resp.conflicts) &&
              resp.conflicts.length
            ) {
              conflictIds = resp.conflicts.map((n) => Number(n));
            } else if (resp && (resp.message || resp.msg || resp.error)) {
              const nums = String(resp.message || resp.msg || resp.error).match(
                /\d+/g,
              );
              if (nums && nums.length) conflictIds = nums.map((n) => Number(n));
            }
          } catch (parseErr) {
            console.error("Error parsing server error response", parseErr);
          }

          if (conflictIds.length) {
            this.devices = (this.devices || []).filter(
              (d) => !conflictIds.includes(Number(d.id)),
            );
            if (
              this.pendingAssignment &&
              Array.isArray(this.pendingAssignment.device_ids)
            ) {
              this.pendingAssignment.device_ids =
                this.pendingAssignment.device_ids.filter(
                  (id) => !conflictIds.includes(Number(id)),
                );
            }
            const idsStr = conflictIds.join(", ");
            if (resp && resp.message) {
              this.$message(
                this.$t("Error"),
                resp.message.replace(/(\s*:\s*\d+(,\s*\d+)*)?$/, ": " + idsStr),
                "danger",
              );
            } else {
              this.$message(
                this.$t("Error"),
                this.$t(
                  "Erro ao criar atribuição: Os seguintes dispositivos já estão ativos em outra atribuição: ",
                ) + idsStr,
                "danger",
              );
            }
            return;
          }

          if (resp && resp.message) {
            this.$message(this.$t("Error"), resp.message, "danger");
          } else {
            this.$message(
              this.$t("Error"),
              this.$t(
                "Erro ao criar atribuição ou persistir CRLV. Veículo não foi salvo.",
              ),
              "danger",
            );
          }
        }
      } catch (error) {
        this.$error(error);
      }
    },
    async getVehicle(id) {
      try {
        const api = `${this.apiBase}vehicles/${id}`;
        const response = await axios.get(api, {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        });

        let vehiclePayload = null;
        if (response && response.data) {
          const d = response.data.data;
          if (Array.isArray(d)) {
            vehiclePayload = d[0] || null;
          } else if (d && typeof d === "object") {
            vehiclePayload = d;
          } else if (response.data && typeof response.data === "object") {
            vehiclePayload = response.data;
          }
        }
        this.vehicle = vehiclePayload || {};

        if (this.vehicle && this.vehicle.license_plate) {
          try {
            const normalizedPlate = String(this.vehicle.license_plate)
              .replace(/[-\s]/g, "")
              .toUpperCase();
            this.isMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(
              normalizedPlate,
            );

            if (normalizedPlate) {
              this.vehicle.license_plate = normalizedPlate;
            }
          } catch (e) {
            console.error(e);
          }
        }
      } catch (error) {
        this.$error(error);
      }
    },
    async loadInitialData() {
      try {
        await Promise.all([
          this.getVehicleColors(),
          this.getVehicleBrands(),
          this.getVehicleModels(),
        ]);
      } catch (error) {
        this.$error(error);
      }
    },
    async getVehicleColors() {
      const response = await axios.get(
        this.apiBase + "vehicle_colors?paginated=false",
        {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        },
      );
      this.vehicle_colors = response.data.data;
    },
    async getVehicleBrands() {
      const response = await axios.get(
        this.apiBase + "vehicle_brands?paginated=false",
        {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        },
      );
      this.vehicle_brands = response.data.data;
    },
    async getVehicleModels() {
      const response = await axios.get(
        this.apiBase + "vehicle_models?paginated=false",
        {
          cancelToken: this._cancelSource
            ? this._cancelSource.token
            : undefined,
        },
      );
      this.vehicle_models = response.data.data;
    },
    async onAssignmentChanged() {
      try {
        if (this.vehicle.id) {
          await this.getVehicle(this.vehicle.id);

          this.$message(
            this.$t("Success"),
            this.$t("Vehicle information updated"),
            "info",
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadAssignmentOptions() {
      try {
        this.pendingLoading = true;
        const [types, centers] = await Promise.all([
          axios.get(this.apiBase + "vehicle_types", {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          }),
          axios.get(this.apiBase + "centers", {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          }),
        ]);

        this.vehicleTypes = types.data.data;
        this.centers = centers.data.data;

        this.devices = [];
      } catch (error) {
        this.$error(error);
      } finally {
        this.pendingLoading = false;
      }
    },
    onUnitChange(unitId) {
      this.pendingAssignment.device_ids = [];
      if (unitId) {
        this.loadDevices(unitId);
      } else {
        this.devices = [];
      }
    },
    async loadDevices(unitId) {
      try {
        this.devicesLoading = true;
        let devicesResp;
        if (unitId) {
          devicesResp = await axios.get(
            `${this.apiBase}units/devices/${unitId}`,
            {
              cancelToken: this._cancelSource
                ? this._cancelSource.token
                : undefined,
            },
          );
        } else {
          devicesResp = await axios.get(this.apiBase + "devices", {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          });
        }

        const assignmentsResp = await axios
          .get(this.apiBase + "vehicle_assignments?status=active", {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          })
          .catch(() => ({ data: [] }));

        const rawDevices =
          devicesResp && devicesResp.data
            ? devicesResp.data.data || devicesResp.data
            : [];
        const rawAssignments =
          assignmentsResp && assignmentsResp.data
            ? assignmentsResp.data.data || assignmentsResp.data
            : [];

        const activeDeviceIds = new Set();
        (rawAssignments || []).forEach((a) => {
          if (!a) return;
          if (Array.isArray(a.devices)) {
            a.devices.forEach((d) => {
              if (!d) return;
              if (d.id) activeDeviceIds.add(Number(d.id));
              else if (d.device_id) activeDeviceIds.add(Number(d.device_id));
            });
          }
          if (Array.isArray(a.device_vehicle_assignment)) {
            a.device_vehicle_assignment.forEach((p) => {
              if (p.device_id) activeDeviceIds.add(Number(p.device_id));
            });
          }
        });

        const availableDevices = (rawDevices || []).filter((d) => {
          if (!d) return false;
          return !activeDeviceIds.has(Number(d.id));
        });

        this.devices = (availableDevices || []).map((d) => ({
          id: d.id,
          display:
            (d.imei || d.serial_number || d.id) +
            (d.description ? " - " + d.description : ""),
        }));
      } catch (error) {
        this.$error(error);
      } finally {
        this.devicesLoading = false;
      }
    },
    async loadPendingUnitsForCenter(centerId) {
      this.pendingAssignment.unit_id = null;
      this.pendingAssignment.device_ids = [];
      this.devices = [];
      this.pendingTransferUnits = [];

      if (!centerId) {
        return;
      }
      try {
        const response = await axios.get(
          `${this.apiBase}centers/unit/${centerId}`,
          {
            cancelToken: this._cancelSource
              ? this._cancelSource.token
              : undefined,
          },
        );
        const raw = response && response.data ? response.data : null;
        let unitsArr = [];
        if (Array.isArray(raw)) unitsArr = raw;
        else if (raw && Array.isArray(raw.data)) unitsArr = raw.data;
        else if (raw && Array.isArray(raw)) unitsArr = raw;
        this.pendingTransferUnits = unitsArr.map((u) => ({
          value: u.id,
          text: u.name || u.title || u.description || String(u.id),
        }));
        if (unitsArr.length === 1) {
          this.pendingAssignment.unit_id = unitsArr[0].id;
          this.onUnitChange(unitsArr[0].id);
        } else {
          this.pendingAssignment.unit_id = null;
          this.onUnitChange(null);
        }
      } catch (error) {
        this.$error(error);
      }
    },
  },
  watch: {
    "pendingAssignment.name"(val) {
      this.vehicle.name = val || "";
    },
    "pendingAssignment.vehicle_type_id"(val) {
      this.vehicle.vehicle_type_id = val || null;
      const found =
        this.vehicleTypes &&
        this.vehicleTypes.find((x) => String(x.id) === String(val));
      this.pendingAssignment.specialty = found
        ? found.description || found.name || found.sigla || ""
        : "";
    },
    "pendingAssignment.specialty"(val) {
      this.vehicle.specialty = val || "";
    },
    // "pendingAssignment.telephone_pulsos"(val) {
    //   this.vehicle.telephone_pulsos = val || "";
    // },
    "pendingAssignment.center_id"(val) {
      this.vehicle.center_id = val || null;
    },
    "pendingAssignment.unit_id"(val) {
      this.vehicle.unit_id = val || null;
    },
  },
  async mounted() {
    this._cancelSource = axios.CancelToken ? axios.CancelToken.source() : null;
    this.initializing = true;
    const id = this.$route.params.id;
    if (id) this.checkingVehicle = true;
    try {
      await this.loadInitialData();
      await this.loadAssignmentOptions();

      if (id) {
        await this.getVehicle(id);
      }
    } catch (error) {
      this.$error(error);
    } finally {
      this.initializing = false;
      this.checkingVehicle = false;
    }
  },
  beforeDestroy() {
    if (this._cancelSource) {
      this._cancelSource.cancel();
    }
  },
};
</script>

<style scoped>
.required_fields {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}

.vselect {
  width: 100% !important;
}

.is-invalid {
  border-color: #e3342f !important;
}

.invalid-feedback {
  display: block;
}
</style>
